class EventDispatcher {
  // ## Constructor ###
  constructor() {
    this.events = {};
  }
  /**
  * On
  * @param String eventName
  * @param Function eventHandler
  **/
  on(eventName, eventHandler) {
    this.events[eventName] = eventHandler;
  } 
  off(eventName, eventHandler) {
    if (this.events[eventName]) {
      delete this.events[eventName];
    }
  }
  dispatch(eventName) {
    if (this.events[eventName]) {
      let e = {
        type: eventName,
        target: this
      };
      this.events[eventName](e);
    }
  }
}

export default EventDispatcher;

